// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O_aeYwLW6aHfNeWcOwxD {
    display: flex;
    align-items: center;
    cursor: pointer;
    overflow-wrap: break-word;
    max-width: calc(100vw - 64px);
}

.l4dXe0IuxDRQDrJHqW5N {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.rdVvNPW9haxtsjXSZPng {
    overflow-wrap: break-word;
}

.XerwotaaFjd0Ijz6klAj {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
}

.Ocd_An222NMdSGY_IDsq {
    overflow-wrap: break-word;
}

.zdaSjJWQxGCy2SiBlbKg {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.gqpxoA7ZmdfCflsEpgyH {
    margin: 0 4px;
}

.KNM_0kB3e25rmtA_MWnM {
    width: 40px !important;
    height: 40px !important;
    font-size: 16px !important;
    margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/ListItem/ListItem.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;AACtB","sourcesContent":[".wrapper {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    overflow-wrap: break-word;\n    max-width: calc(100vw - 64px);\n}\n\n.content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.title {\n    overflow-wrap: break-word;\n}\n\n.serviceDetails {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.description {\n    overflow-wrap: break-word;\n}\n\n.servicePriceDuration {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.pipe {\n    margin: 0 4px;\n}\n\n.avatar {\n    width: 40px !important;\n    height: 40px !important;\n    font-size: 16px !important;\n    margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `O_aeYwLW6aHfNeWcOwxD`,
	"content": `l4dXe0IuxDRQDrJHqW5N`,
	"title": `rdVvNPW9haxtsjXSZPng`,
	"serviceDetails": `XerwotaaFjd0Ijz6klAj`,
	"description": `Ocd_An222NMdSGY_IDsq`,
	"servicePriceDuration": `zdaSjJWQxGCy2SiBlbKg`,
	"pipe": `gqpxoA7ZmdfCflsEpgyH`,
	"avatar": `KNM_0kB3e25rmtA_MWnM`
};
export default ___CSS_LOADER_EXPORT___;
